export const SESSION_STORAGE_KEY = 'dynamicClientType';
